export default "__VITE_ASSET__Djl882pe__"